'use client';
"use strict";

var _excluded = ["closeOnBlur", "closeOnEsc", "initialFocusRef", "id", "returnFocusOnClose", "autoFocus", "arrowSize", "arrowShadowColor", "trigger", "openDelay", "closeDelay", "isLazy", "lazyBehavior", "computePositionOnMount"],
    _excluded2 = ["children"],
    _excluded3 = ["variants"],
    _excluded4 = ["rootProps", "motionProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Popover: function Popover() {
    return _Popover;
  },
  PopoverAnchor: function PopoverAnchor() {
    return _PopoverAnchor;
  },
  PopoverArrow: function PopoverArrow() {
    return _PopoverArrow;
  },
  PopoverBody: function PopoverBody() {
    return _PopoverBody;
  },
  PopoverCloseButton: function PopoverCloseButton() {
    return _PopoverCloseButton;
  },
  PopoverContent: function PopoverContent() {
    return _PopoverContent;
  },
  PopoverFooter: function PopoverFooter() {
    return _PopoverFooter;
  },
  PopoverHeader: function PopoverHeader() {
    return _PopoverHeader;
  },
  PopoverTrigger: function PopoverTrigger() {
    return _PopoverTrigger;
  },
  usePopover: function usePopover() {
    return _usePopover;
  },
  usePopoverContext: function usePopoverContext() {
    return _usePopoverContext;
  },
  usePopoverStyles: function usePopoverStyles() {
    return _usePopoverStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/popover.tsx

var import_system = require("@chakra-ui/system");

var import_shared_utils2 = require("@chakra-ui/shared-utils"); // src/popover-context.ts


var import_react_context = require("@chakra-ui/react-context");

var _ref2 = (0, import_react_context.createContext)({
  name: "PopoverContext",
  errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
}),
    _ref3 = _slicedToArray(_ref2, 2),
    PopoverProvider = _ref3[0],
    _usePopoverContext = _ref3[1];

var _ref4 = (0, import_react_context.createContext)({
  name: "PopoverStylesContext",
  errorMessage: "usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Popover />\" "
}),
    _ref5 = _slicedToArray(_ref4, 2),
    PopoverStylesProvider = _ref5[0],
    _usePopoverStyles = _ref5[1]; // src/use-popover.ts


var import_react_use_animation_state = require("@chakra-ui/react-use-animation-state");

var import_react_use_focus_on_pointer_down = require("@chakra-ui/react-use-focus-on-pointer-down");

var import_react_use_focus_effect = require("@chakra-ui/react-use-focus-effect");

var import_react_use_disclosure = require("@chakra-ui/react-use-disclosure");

var import_popper = require("@chakra-ui/popper");

var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");

var import_shared_utils = require("@chakra-ui/shared-utils");

var import_lazy_utils = require("@chakra-ui/lazy-utils");

var import_react = require("react");

var TRIGGER = {
  click: "click",
  hover: "hover"
};

function _usePopover() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _props$closeOnBlur = props.closeOnBlur,
      closeOnBlur = _props$closeOnBlur === void 0 ? true : _props$closeOnBlur,
      _props$closeOnEsc = props.closeOnEsc,
      closeOnEsc = _props$closeOnEsc === void 0 ? true : _props$closeOnEsc,
      initialFocusRef = props.initialFocusRef,
      id = props.id,
      _props$returnFocusOnC = props.returnFocusOnClose,
      returnFocusOnClose = _props$returnFocusOnC === void 0 ? true : _props$returnFocusOnC,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      arrowSize = props.arrowSize,
      arrowShadowColor = props.arrowShadowColor,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? TRIGGER.click : _props$trigger,
      _props$openDelay = props.openDelay,
      openDelay = _props$openDelay === void 0 ? 200 : _props$openDelay,
      _props$closeDelay = props.closeDelay,
      closeDelay = _props$closeDelay === void 0 ? 200 : _props$closeDelay,
      isLazy = props.isLazy,
      _props$lazyBehavior = props.lazyBehavior,
      lazyBehavior = _props$lazyBehavior === void 0 ? "unmount" : _props$lazyBehavior,
      computePositionOnMount = props.computePositionOnMount,
      popperProps = _objectWithoutProperties(props, _excluded);

  var _ref6 = (0, import_react_use_disclosure.useDisclosure)(props),
      isOpen = _ref6.isOpen,
      onClose = _ref6.onClose,
      onOpen = _ref6.onOpen,
      onToggle = _ref6.onToggle;

  var anchorRef = (0, import_react.useRef)(null);
  var triggerRef = (0, import_react.useRef)(null);
  var popoverRef = (0, import_react.useRef)(null);
  var isHoveringRef = (0, import_react.useRef)(false);
  var hasBeenOpened = (0, import_react.useRef)(false);

  if (isOpen) {
    hasBeenOpened.current = true;
  }

  var _ref7 = (0, import_react.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      hasHeader = _ref8[0],
      setHasHeader = _ref8[1];

  var _ref9 = (0, import_react.useState)(false),
      _ref10 = _slicedToArray(_ref9, 2),
      hasBody = _ref10[0],
      setHasBody = _ref10[1];

  var uuid = (0, import_react.useId)();
  var uid = id != null ? id : uuid;

  var _map = ["popover-trigger", "popover-content", "popover-header", "popover-body"].map(function (id2) {
    return "".concat(id2, "-").concat(uid);
  }),
      _map2 = _slicedToArray(_map, 4),
      triggerId = _map2[0],
      popoverId = _map2[1],
      headerId = _map2[2],
      bodyId = _map2[3];

  var _ref11 = (0, import_popper.usePopper)(_objectSpread(_objectSpread({}, popperProps), {}, {
    enabled: isOpen || !!computePositionOnMount
  })),
      referenceRef = _ref11.referenceRef,
      getArrowProps = _ref11.getArrowProps,
      getPopperProps = _ref11.getPopperProps,
      getArrowInnerProps = _ref11.getArrowInnerProps,
      forceUpdate = _ref11.forceUpdate;

  var animated = (0, import_react_use_animation_state.useAnimationState)({
    isOpen: isOpen,
    ref: popoverRef
  });
  (0, import_react_use_focus_on_pointer_down.useFocusOnPointerDown)({
    enabled: isOpen,
    ref: triggerRef
  });
  (0, import_react_use_focus_effect.useFocusOnHide)(popoverRef, {
    focusRef: triggerRef,
    visible: isOpen,
    shouldFocus: returnFocusOnClose && trigger === TRIGGER.click
  });
  (0, import_react_use_focus_effect.useFocusOnShow)(popoverRef, {
    focusRef: initialFocusRef,
    visible: isOpen,
    shouldFocus: autoFocus && trigger === TRIGGER.click
  });
  var shouldRenderChildren = (0, import_lazy_utils.lazyDisclosure)({
    wasSelected: hasBeenOpened.current,
    enabled: isLazy,
    mode: lazyBehavior,
    isSelected: animated.present
  });
  var getPopoverProps = (0, import_react.useCallback)(function () {
    var _objectSpread2;

    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var popoverProps = _objectSpread(_objectSpread({}, props2), {}, {
      style: _objectSpread(_objectSpread({}, props2.style), {}, (_objectSpread2 = {
        transformOrigin: import_popper.popperCSSVars.transformOrigin.varRef
      }, _defineProperty(_objectSpread2, import_popper.popperCSSVars.arrowSize.var, arrowSize ? "".concat(arrowSize, "px") : void 0), _defineProperty(_objectSpread2, import_popper.popperCSSVars.arrowShadowColor.var, arrowShadowColor), _objectSpread2)),
      ref: (0, import_react_use_merge_refs.mergeRefs)(popoverRef, _ref),
      children: shouldRenderChildren ? props2.children : null,
      id: popoverId,
      tabIndex: -1,
      role: "dialog",
      onKeyDown: (0, import_shared_utils.callAllHandlers)(props2.onKeyDown, function (event) {
        if (closeOnEsc && event.key === "Escape") {
          onClose();
        }
      }),
      onBlur: (0, import_shared_utils.callAllHandlers)(props2.onBlur, function (event) {
        var relatedTarget = getRelatedTarget(event);
        var targetIsPopover = contains(popoverRef.current, relatedTarget);
        var targetIsTrigger = contains(triggerRef.current, relatedTarget);
        var isValidBlur = !targetIsPopover && !targetIsTrigger;

        if (isOpen && closeOnBlur && isValidBlur) {
          onClose();
        }
      }),
      "aria-labelledby": hasHeader ? headerId : void 0,
      "aria-describedby": hasBody ? bodyId : void 0
    });

    if (trigger === TRIGGER.hover) {
      popoverProps.role = "tooltip";
      popoverProps.onMouseEnter = (0, import_shared_utils.callAllHandlers)(props2.onMouseEnter, function () {
        isHoveringRef.current = true;
      });
      popoverProps.onMouseLeave = (0, import_shared_utils.callAllHandlers)(props2.onMouseLeave, function (event) {
        if (event.nativeEvent.relatedTarget === null) {
          return;
        }

        isHoveringRef.current = false;
        setTimeout(function () {
          return onClose();
        }, closeDelay);
      });
    }

    return popoverProps;
  }, [shouldRenderChildren, popoverId, hasHeader, headerId, hasBody, bodyId, trigger, closeOnEsc, onClose, isOpen, closeOnBlur, closeDelay, arrowShadowColor, arrowSize]);
  var getPopoverPositionerProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return getPopperProps(_objectSpread(_objectSpread({}, props2), {}, {
      style: _objectSpread({
        visibility: isOpen ? "visible" : "hidden"
      }, props2.style)
    }), forwardedRef);
  }, [isOpen, getPopperProps]);
  var getAnchorProps = (0, import_react.useCallback)(function (props2) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _objectSpread(_objectSpread({}, props2), {}, {
      // If anchor is rendered, it is used as reference.
      ref: (0, import_react_use_merge_refs.mergeRefs)(_ref, anchorRef, referenceRef)
    });
  }, [anchorRef, referenceRef]);
  var openTimeout = (0, import_react.useRef)();
  var closeTimeout = (0, import_react.useRef)();
  var maybeReferenceRef = (0, import_react.useCallback)(function (node) {
    if (anchorRef.current == null) {
      referenceRef(node);
    }
  }, [referenceRef]);
  var getTriggerProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var triggerProps = _objectSpread(_objectSpread({}, props2), {}, {
      ref: (0, import_react_use_merge_refs.mergeRefs)(triggerRef, _ref, maybeReferenceRef),
      id: triggerId,
      "aria-haspopup": "dialog",
      "aria-expanded": isOpen,
      "aria-controls": popoverId
    });

    if (trigger === TRIGGER.click) {
      triggerProps.onClick = (0, import_shared_utils.callAllHandlers)(props2.onClick, onToggle);
    }

    if (trigger === TRIGGER.hover) {
      triggerProps.onFocus = (0, import_shared_utils.callAllHandlers)(props2.onFocus, function () {
        if (openTimeout.current === void 0) {
          onOpen();
        }
      });
      triggerProps.onBlur = (0, import_shared_utils.callAllHandlers)(props2.onBlur, function (event) {
        var relatedTarget = getRelatedTarget(event);
        var isValidBlur = !contains(popoverRef.current, relatedTarget);

        if (isOpen && closeOnBlur && isValidBlur) {
          onClose();
        }
      });
      triggerProps.onKeyDown = (0, import_shared_utils.callAllHandlers)(props2.onKeyDown, function (event) {
        if (event.key === "Escape") {
          onClose();
        }
      });
      triggerProps.onMouseEnter = (0, import_shared_utils.callAllHandlers)(props2.onMouseEnter, function () {
        isHoveringRef.current = true;
        openTimeout.current = window.setTimeout(function () {
          return onOpen();
        }, openDelay);
      });
      triggerProps.onMouseLeave = (0, import_shared_utils.callAllHandlers)(props2.onMouseLeave, function () {
        isHoveringRef.current = false;

        if (openTimeout.current) {
          clearTimeout(openTimeout.current);
          openTimeout.current = void 0;
        }

        closeTimeout.current = window.setTimeout(function () {
          if (isHoveringRef.current === false) {
            onClose();
          }
        }, closeDelay);
      });
    }

    return triggerProps;
  }, [triggerId, isOpen, popoverId, trigger, maybeReferenceRef, onToggle, onOpen, closeOnBlur, onClose, openDelay, closeDelay]);
  (0, import_react.useEffect)(function () {
    return function () {
      if (openTimeout.current) {
        clearTimeout(openTimeout.current);
      }

      if (closeTimeout.current) {
        clearTimeout(closeTimeout.current);
      }
    };
  }, []);
  var getHeaderProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      id: headerId,
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, function (node) {
        setHasHeader(!!node);
      })
    });
  }, [headerId]);
  var getBodyProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      id: bodyId,
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, function (node) {
        setHasBody(!!node);
      })
    });
  }, [bodyId]);
  return {
    forceUpdate: forceUpdate,
    isOpen: isOpen,
    onAnimationComplete: animated.onComplete,
    onClose: onClose,
    getAnchorProps: getAnchorProps,
    getArrowProps: getArrowProps,
    getArrowInnerProps: getArrowInnerProps,
    getPopoverPositionerProps: getPopoverPositionerProps,
    getPopoverProps: getPopoverProps,
    getTriggerProps: getTriggerProps,
    getHeaderProps: getHeaderProps,
    getBodyProps: getBodyProps
  };
}

function contains(parent, child) {
  return parent === child || (parent == null ? void 0 : parent.contains(child));
}

function getRelatedTarget(event) {
  var _a;

  var activeEl = event.currentTarget.ownerDocument.activeElement;
  return (_a = event.relatedTarget) != null ? _a : activeEl;
} // src/popover.tsx


var import_jsx_runtime = require("react/jsx-runtime");

function _Popover(props) {
  var styles = (0, import_system.useMultiStyleConfig)("Popover", props);

  var _ref12 = (0, import_system.omitThemingProps)(props),
      children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, _excluded2);

  var theme = (0, import_system.useTheme)();

  var context = _usePopover(_objectSpread(_objectSpread({}, rest), {}, {
    direction: theme.direction
  }));

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(PopoverProvider, {
    value: context,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(PopoverStylesProvider, {
      value: styles,
      children: (0, import_shared_utils2.runIfFn)(children, {
        isOpen: context.isOpen,
        onClose: context.onClose,
        forceUpdate: context.forceUpdate
      })
    })
  });
}

_Popover.displayName = "Popover"; // src/popover-anchor.tsx

var import_react2 = require("react");

function _PopoverAnchor(props) {
  var child = import_react2.Children.only(props.children);

  var _usePopoverContext2 = _usePopoverContext(),
      getAnchorProps = _usePopoverContext2.getAnchorProps;

  return (0, import_react2.cloneElement)(child, getAnchorProps(child.props, child.ref));
}

_PopoverAnchor.displayName = "PopoverAnchor"; // src/popover-arrow.tsx

var import_system2 = require("@chakra-ui/system");

var import_shared_utils3 = require("@chakra-ui/shared-utils");

var import_jsx_runtime2 = require("react/jsx-runtime");

var resolveVar = function resolveVar(scale, value) {
  return value ? "".concat(scale, ".").concat(value, ", ").concat(value) : void 0;
};

function _PopoverArrow(props) {
  var _a;

  var bg = props.bg,
      bgColor = props.bgColor,
      backgroundColor = props.backgroundColor,
      shadow = props.shadow,
      boxShadow = props.boxShadow,
      shadowColor = props.shadowColor;

  var _usePopoverContext3 = _usePopoverContext(),
      getArrowProps = _usePopoverContext3.getArrowProps,
      getArrowInnerProps = _usePopoverContext3.getArrowInnerProps;

  var styles = _usePopoverStyles();

  var arrowBg = (_a = bg != null ? bg : bgColor) != null ? _a : backgroundColor;
  var arrowShadow = shadow != null ? shadow : boxShadow;
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.div, _objectSpread(_objectSpread({}, getArrowProps()), {}, {
    className: "chakra-popover__arrow-positioner",
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.div, _objectSpread(_objectSpread({
      className: (0, import_shared_utils3.cx)("chakra-popover__arrow", props.className)
    }, getArrowInnerProps(props)), {}, {
      __css: _objectSpread({
        "--popper-arrow-shadow-color": resolveVar("colors", shadowColor),
        "--popper-arrow-bg": resolveVar("colors", arrowBg),
        "--popper-arrow-shadow": resolveVar("shadows", arrowShadow)
      }, styles.arrow)
    }))
  }));
}

_PopoverArrow.displayName = "PopoverArrow"; // src/popover-body.tsx

var import_system3 = require("@chakra-ui/system");

var import_shared_utils4 = require("@chakra-ui/shared-utils");

var import_jsx_runtime3 = require("react/jsx-runtime");

var _PopoverBody = (0, import_system3.forwardRef)(function PopoverBody2(props, ref) {
  var _usePopoverContext4 = _usePopoverContext(),
      getBodyProps = _usePopoverContext4.getBodyProps;

  var styles = _usePopoverStyles();

  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_system3.chakra.div, _objectSpread(_objectSpread({}, getBodyProps(props, ref)), {}, {
    className: (0, import_shared_utils4.cx)("chakra-popover__body", props.className),
    __css: styles.body
  }));
});

_PopoverBody.displayName = "PopoverBody"; // src/popover-close-button.tsx

var import_close_button = require("@chakra-ui/close-button");

var import_system4 = require("@chakra-ui/system");

var import_shared_utils5 = require("@chakra-ui/shared-utils");

var import_jsx_runtime4 = require("react/jsx-runtime");

var _PopoverCloseButton = (0, import_system4.forwardRef)(function PopoverCloseButton2(props, ref) {
  var _usePopoverContext5 = _usePopoverContext(),
      onClose = _usePopoverContext5.onClose;

  var styles = _usePopoverStyles();

  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_close_button.CloseButton, _objectSpread({
    size: "sm",
    onClick: onClose,
    className: (0, import_shared_utils5.cx)("chakra-popover__close-btn", props.className),
    __css: styles.closeButton,
    ref: ref
  }, props));
});

_PopoverCloseButton.displayName = "PopoverCloseButton"; // src/popover-content.tsx

var import_shared_utils6 = require("@chakra-ui/shared-utils");

var import_system6 = require("@chakra-ui/system"); // src/popover-transition.tsx


var import_system5 = require("@chakra-ui/system");

var import_framer_motion = require("framer-motion");

var import_jsx_runtime5 = require("react/jsx-runtime");

function mergeVariants(variants) {
  if (!variants) return;
  return {
    enter: _objectSpread(_objectSpread({}, variants.enter), {}, {
      visibility: "visible"
    }),
    exit: _objectSpread(_objectSpread({}, variants.exit), {}, {
      transitionEnd: {
        visibility: "hidden"
      }
    })
  };
}

var scaleFade = {
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  }
};
var MotionSection = (0, import_system5.chakra)(import_framer_motion.motion.section);
var PopoverTransition = (0, import_system5.forwardRef)(function PopoverTransition2(props, ref) {
  var _props$variants = props.variants,
      variants = _props$variants === void 0 ? scaleFade : _props$variants,
      rest = _objectWithoutProperties(props, _excluded3);

  var _usePopoverContext6 = _usePopoverContext(),
      isOpen = _usePopoverContext6.isOpen;

  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(MotionSection, _objectSpread({
    ref: ref,
    variants: mergeVariants(variants),
    initial: false,
    animate: isOpen ? "enter" : "exit"
  }, rest));
});
PopoverTransition.displayName = "PopoverTransition"; // src/popover-content.tsx

var import_jsx_runtime6 = require("react/jsx-runtime");

var _PopoverContent = (0, import_system6.forwardRef)(function PopoverContent2(props, ref) {
  var rootProps = props.rootProps,
      motionProps = props.motionProps,
      contentProps = _objectWithoutProperties(props, _excluded4);

  var _usePopoverContext7 = _usePopoverContext(),
      getPopoverProps = _usePopoverContext7.getPopoverProps,
      getPopoverPositionerProps = _usePopoverContext7.getPopoverPositionerProps,
      onAnimationComplete = _usePopoverContext7.onAnimationComplete;

  var styles = _usePopoverStyles();

  var contentStyles = _objectSpread({
    position: "relative",
    display: "flex",
    flexDirection: "column"
  }, styles.content);

  return /* @__PURE__ */(0, import_jsx_runtime6.jsx)(import_system6.chakra.div, _objectSpread(_objectSpread({}, getPopoverPositionerProps(rootProps)), {}, {
    __css: styles.popper,
    className: "chakra-popover__popper",
    children: /* @__PURE__ */(0, import_jsx_runtime6.jsx)(PopoverTransition, _objectSpread(_objectSpread(_objectSpread({}, motionProps), getPopoverProps(contentProps, ref)), {}, {
      onAnimationComplete: (0, import_shared_utils6.callAll)(onAnimationComplete, contentProps.onAnimationComplete),
      className: (0, import_shared_utils6.cx)("chakra-popover__content", props.className),
      __css: contentStyles
    }))
  }));
});

_PopoverContent.displayName = "PopoverContent"; // src/popover-footer.tsx

var import_system7 = require("@chakra-ui/system");

var import_shared_utils7 = require("@chakra-ui/shared-utils");

var import_jsx_runtime7 = require("react/jsx-runtime");

function _PopoverFooter(props) {
  var styles = _usePopoverStyles();

  return /* @__PURE__ */(0, import_jsx_runtime7.jsx)(import_system7.chakra.footer, _objectSpread(_objectSpread({}, props), {}, {
    className: (0, import_shared_utils7.cx)("chakra-popover__footer", props.className),
    __css: styles.footer
  }));
}

_PopoverFooter.displayName = "PopoverFooter"; // src/popover-header.tsx

var import_system8 = require("@chakra-ui/system");

var import_shared_utils8 = require("@chakra-ui/shared-utils");

var import_jsx_runtime8 = require("react/jsx-runtime");

var _PopoverHeader = (0, import_system8.forwardRef)(function PopoverHeader2(props, ref) {
  var _usePopoverContext8 = _usePopoverContext(),
      getHeaderProps = _usePopoverContext8.getHeaderProps;

  var styles = _usePopoverStyles();

  return /* @__PURE__ */(0, import_jsx_runtime8.jsx)(import_system8.chakra.header, _objectSpread(_objectSpread({}, getHeaderProps(props, ref)), {}, {
    className: (0, import_shared_utils8.cx)("chakra-popover__header", props.className),
    __css: styles.header
  }));
});

_PopoverHeader.displayName = "PopoverHeader"; // src/popover-trigger.tsx

var import_react3 = require("react");

function _PopoverTrigger(props) {
  var child = import_react3.Children.only(props.children);

  var _usePopoverContext9 = _usePopoverContext(),
      getTriggerProps = _usePopoverContext9.getTriggerProps;

  return (0, import_react3.cloneElement)(child, getTriggerProps(child.props, child.ref));
}

_PopoverTrigger.displayName = "PopoverTrigger"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  Popover: _Popover,
  PopoverAnchor: _PopoverAnchor,
  PopoverArrow: _PopoverArrow,
  PopoverBody: _PopoverBody,
  PopoverCloseButton: _PopoverCloseButton,
  PopoverContent: _PopoverContent,
  PopoverFooter: _PopoverFooter,
  PopoverHeader: _PopoverHeader,
  PopoverTrigger: _PopoverTrigger,
  usePopover: _usePopover,
  usePopoverContext: _usePopoverContext,
  usePopoverStyles: _usePopoverStyles
});